// extracted by mini-css-extract-plugin
export default {"container":"simple_container__2sQ6b","inner":"simple_inner__2-F_d","header":"simple_header__3Qd4a","draw-path":"simple_draw-path__1rH3M"};